module.exports = __webpack_public_path__ + "img/icon7.dc621ba3.svg";